import { Breadcrumb, Button, Card, Col, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg"
import PND3ReportModal from "../reportModal/PND3ReportModal";

const PND3ReportComponent = ({
    pdfUrl,
    showReport,
    showModal,
    isModalOpen = false,
    handleSearch = () => { },
    setIsModalOpen = () => { },
    exportPND3ReportDocument = () => { },
    exportPND3Report = () => { },
    exportPND3ReportZip = () => { },
    searchValues,
    isDownloadDoc = false,
    isDownload = false,
    isDownloadZip = false
}) => {
    const { t } = useTranslation();
    return (
        <MainLayout>
            <PND3ReportModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                exportPND3ReportDocument={exportPND3ReportDocument}
                exportPND3Report={exportPND3Report}
                exportPND3ReportZip={exportPND3ReportZip}
                searchValues={searchValues}
                isDownloadDoc={isDownloadDoc}
                isDownload={isDownload}
                isDownloadZip={isDownloadZip}
            />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("report.header"), href: "" },
                        { title: t("salary_calculation_group.header"), href: "" },
                        { title: t("pnd_3.header") }
                    ]} />
                    <h2>{t("pnd_3.header")}</h2>
                </Flex>

                <FormAntd onFinish={handleSearch}
                    initialValues={{ year: dayjs() }}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card
                                        style={{
                                            backgroundColor: "white",
                                            width: "100%",
                                            marginBottom: "1vw",
                                            border: "1px solid #EAECF0",
                                        }}
                                    >
                                        <Flex vertical gap={16}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={12}>
                                                    <FormDatePicker
                                                        name="year"
                                                        dateFormat={"YYYY"}
                                                        picker="year"
                                                        label={t('payroll_period.label.tax_year')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        required
                                                        onChange={(value) => {
                                                            const selectedYear = value?.year() || dayjs().year();
                                                            // setYear(selectedYear);
                                                            setFieldValue("year", value);
                                                        }}
                                                    />
                                                </Col>

                                                <Col span={12}>
                                                    <FormDatePicker
                                                        name="month"
                                                        required
                                                        label={t('unit.month')}
                                                        allowClear
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                        picker="month"
                                                        dateFormat="MMMM"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px", marginTop: "24px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                    <Flex gap={8}>
                                                        <DownloadIcon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>

                                            <iframe
                                                src={pdfUrl}
                                                title="PND3 Report Preview"
                                                width="100%"
                                                height="600px"
                                                style={{
                                                    border: "1px solid #ccc",
                                                    borderRadius: "8px",
                                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
                                                }}
                                            />

                                        </Space>
                                    )}
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    )
}

export default PND3ReportComponent;